import React from "react";

// CSS
import "./J2PageNotFound.css";
import pageNotFoundImage from "../../../images/norman-404.jpg";

// REACT COMPONENT
function J2PageNotFound() {
	return (
		<div className="J2PageNotFound">
			<h1 className="pageNotFoundTitle">Page Not Found (404)</h1>
			<div className="imageContainer">
				<img src={pageNotFoundImage} alt="Page Not Found" />
			</div>
			<p className="notFoundMessage">
				When Norman hits your eye like a big pizza pie, that's a
				404-ay. Return to the home page <a href="/">here</a>.
			</p>
		</div>
	);
}

export default J2PageNotFound;
